import type { CSSProperties, ReactNode } from 'react';

/**
 * TabPane 标题统一辅助组件（icon-map.md §1.2）：icon + 文案 + 角标 横向排布。
 * - 图标（Arco icon 或 components/icons 自定义图标均可）包在 .bcc-tab-icon 内：
 *   统一 16px、与文字右间距 6px、颜色 color:inherit（选中态随 Arco Tabs 主色切换）；
 * - 文案与角标沿用既有结构：角标传 .bcc-tab-badge 计数胶囊即可（margin-left 已内置）。
 * 用法：`title={<TabTitle icon={<IconQueue />} label="队列实况" badge={queueCount > 0 ? <span className="bcc-tab-badge bcc-mono">{queueCount}</span> : undefined} />}`
 */
export interface TabTitleProps {
  /** 图标节点（可选）；Arco icon 或自定义业务图标均可 */
  icon?: ReactNode;
  /** Tab 文案 */
  label: ReactNode;
  /** 角标节点（可选）；沿用 .bcc-tab-badge（计数胶囊）或 Arco Badge */
  badge?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export default function TabTitle({ icon, label, badge, className, style }: TabTitleProps) {
  return (
    <span className={`bcc-tab-title${className ? ` ${className}` : ''}`} style={style}>
      {icon != null && <span className="bcc-tab-icon">{icon}</span>}
      <span className="bcc-tab-title-text">{label}</span>
      {badge}
    </span>
  );
}
